/* ef-orderform-simple.js (2026-05-08)
 * Quick Ship variant of the orderform — for products with cfg-simple data
 * schema (simple_width / simple_height / simple_models). Two size dropdowns
 * (width range + height range) → resolves to a model + overall dimensions.
 * Same look-and-feel as ef-orderform-doors.js but ~10x smaller.
 */
(function () {
  'use strict';

  var root = document.getElementById('efOf');
  if (!root) return;

  var BASE_VARIANT_ID = root.dataset.variantId || '';
  var BASE_PRICE = parseInt(root.dataset.basePrice || '0', 10);
  var PRODUCT_HANDLE = root.dataset.productHandle || '';
  var PRODUCT_TITLE = root.dataset.productTitle || '';
  var CFG_GROUP = root.dataset.cfgGroup || '';
  var compactOrder = root.hasAttribute('data-ef-simple-order');
  // Exact native sibling products: never apply this availability rule by fuzzy title.
  var isArdmore = PRODUCT_HANDLE === 'ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design';
  var isArmitage = PRODUCT_HANDLE === 'armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design';
  var colorFamilies = [
    [{handle:'ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design',label:'Black'},{handle:'armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design',label:'Dark Grey'}],
    [{handle:'finley-flat-black-masonry-fireplace-door-standard-sizes',label:'Black'},{handle:'farnsworth-oil-rubbed-bronze-masonry-fireplace-door-standard-sizes',label:'Oil Rubbed Bronze'}]
  ];
  var colorFamily = colorFamilies.find(function (family) { return family.some(function (p) { return p.handle === PRODUCT_HANDLE; }); });
  var hasColorFamily = !!colorFamily;
  function selectedColorLabel() { var p = colorFamily && colorFamily.find(function (p) { return p.handle === PRODUCT_HANDLE; }); return p ? p.label : ''; }

  // One presentation source for all shipping surfaces. Preserve the existing
  // owner-confirmed Ardmore Small exception and each product's server lead time.
  var shippingHero = document.querySelector('.ef-lab-standard-doors .efx-pdp__leadtime > span');
  var shippingDefault = shippingHero ? shippingHero.innerHTML : '';
  var shippingBaseText = shippingHero ? shippingHero.textContent.replace(/^.*?·\s*/, '') : '';
  function syncArdmoreLead() {
    var w = widthSel.options[widthSel.selectedIndex], h = heightSel.options[heightSel.selectedIndex];
    var selected = !!(state.width && state.height);
    var small = selected && w && h && w.dataset.idx === '0' && h.dataset.idx === '0';
    var pending = isArdmore && !selected;
    var shippingText = pending ? 'Select a size for shipping time' : isArdmore && small ? 'Ships in 6–10 days' : shippingBaseText.replace(/^s/, 'S').replace(/(\d)-(\d)/g, '$1–$2');
    if (shippingHero) {
      if (pending) shippingHero.textContent = shippingText;
      else if (isArdmore && small) shippingHero.innerHTML = '<b>In stock</b> · ships in 6–10 days';
      else shippingHero.innerHTML = shippingDefault;
    }
    document.querySelectorAll('.ef-lab-standard-doors #efSimpleLead, .ef-lab-standard-doors #pdp-trust .ef-lab-dispatch, .ef-lab-standard-doors a[href="#spec-ship"] .efx-specs__rf, .ef-lab-standard-doors #spec-ship .efx-specs__sf').forEach(function (el) { el.textContent = shippingText; });
  }
  function syncColorLinks() {
    if (!hasColorFamily) return;
    var w = widthSel.options[widthSel.selectedIndex], h = heightSel.options[heightSel.selectedIndex];
    var size = state.width && state.height ? (w.dataset.idx === '1' ? 'L' : h.dataset.idx === '1' ? 'M' : 'S') : '';
    root.querySelectorAll('[data-ef-color-target]').forEach(function (link) {
      var url = new URL(link.href, window.location.href);
      if (size) url.searchParams.set('ef_size', size); else url.searchParams.delete('ef_size');
      link.href = url.href;
    });
    root.setAttribute('data-size-unavailable', 'false');
  }
  function restoreColorSize() {
    if (!hasColorFamily || !groupData) return;
    var size = new URLSearchParams(window.location.search).get('ef_size');
    var pair = { S: [0, 0], M: [0, 1], L: [1, 0] }[size];
    if (!pair) return;
    var w = widthSel.querySelector('option[data-idx="' + pair[0] + '"]');
    if (!w) return;
    widthSel.value = w.value;
    onWidthChange();
    var h = heightSel.querySelector('option[data-idx="' + pair[1] + '"]');
    // Preserve the chosen size when switching native color products.
    if (h) { heightSel.value = h.value; onSizeChange(); }
  }

  var widthSel = document.getElementById('efOfSimpleWidth');
  var heightSel = document.getElementById('efOfSimpleHeight');
  var overallBox = document.getElementById('efOfSimpleOverall');
  var overallModel = document.getElementById('efOfSimpleModel');
  var overallDims = document.getElementById('efOfSimpleDims');
  var msgEl = document.getElementById('efOfMsg');
  var atcBtn = document.getElementById('efOfAtc');
  var atcLabel = atcBtn && atcBtn.querySelector('.ef-of__atc-label');
  var totalAmt = document.getElementById('efOfTotalAmt');
  var baseAmt = document.getElementById('efOfBaseAmt');
  var notesEl = document.getElementById('efOfNotes');
  var fileInput = document.getElementById('efOfFile');
  var fileLabel = document.getElementById('efOfFileLabel');
  var expressBtn = document.getElementById('efOfExpressCheckout');

  function money(cents) {
    var n = Math.round(cents);
    if (n % 100 === 0) return '$' + (n / 100).toLocaleString('en-US');
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }
  function moneyDollars(d) { return money(d * 100); }

  function msg(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'ef-of__msg ef-of__msg--' + (kind || 'ok');
    msgEl.hidden = false;
  }

  /* ── Find the data block — same fuzzy match as orderform-doors. ── */
  function findGroupData() {
    var data = window.EF_CFG_DATA || {};
    var keys = Object.keys(data);
    if (!keys.length) return null;
    if (CFG_GROUP && data[CFG_GROUP]) return data[CFG_GROUP];
    /* Match by slug-last-word in display key (e.g. "doors-ardmore-armitage" → key contains "ardmore") */
    if (CFG_GROUP) {
      var parts = CFG_GROUP.split('-').slice(1).filter(function (p) { return p.length >= 4; });
      for (var i = 0; i < keys.length; i++) {
        var lc = keys[i].toLowerCase();
        for (var j = 0; j < parts.length; j++) {
          if (lc.indexOf(parts[j]) !== -1) return data[keys[i]];
        }
      }
    }
    /* §R9-H5 (2026-09-03) — was `return data[keys[0]];`.
       With no guard, a product whose group did not resolve was served the FIRST
       group in EF_CFG_DATA: another door's widths, heights, model names and
       surcharge VARIANT IDs. The customer could buy a size belonging to a
       different product. Audited first (logs/R9-P1.md, H5): all 7 cfg-simple
       handles resolve through the exact or the fuzzy branch above, so nothing
       reaches this line in production; when something does, it is a defect and
       the error path below must say so instead of guessing. */
    return null;
  }

  /* §R9-H6 (2026-09-03) — the 4,000 ms first checkpoint.
     R9-H2 measured the old single 8,000 ms deadline firing 0 times in 36 cold
     loads (logs/R9-H2-tready.md §1c): `ef-cfg-<group>.js` and this file are
     adjacent in the same `defer` queue, so by the time this clock starts the
     data is already there. The message is reachable only when the asset 404s
     or the group resolves to nothing — which is exactly when a buyer needs it,
     and 8 s is far too late to be told. Four seconds swaps the placeholder
     INSIDE the sizes fieldset; the 8,000 ms deadline still ends the poll. */
  function whenDataReady(cb) {
    var start = Date.now();
    var warned = false;
    function poll() {
      var d = window.EF_CFG_DATA;
      if (d && Object.keys(d).length) return cb(true);
      var age = Date.now() - start;
      if (age > 8000) return cb(false);
      if (!warned && age > 4000) { warned = true; failSizeSelects(); }
      setTimeout(poll, 120);
    }
    poll();
  }

  /* §R9-H6 — the rest state, and the two ways out of it.
     Until this round the two selects were ENABLED from first paint holding one
     silent placeholder each, for a median 24.8 s at Slow 4G (R9-H2). The markup
     now renders them `disabled` with a visible `Loading sizes…`; these two
     functions are the only things that move them off it. */
  function setPlaceholder(sel, text) {
    if (!sel || !sel.options.length) return;
    var o = sel.options[0];
    if (o.value === '') o.textContent = text;
  }
  function enableSizeSelects() {
    if (widthSel) { widthSel.disabled = false; setPlaceholder(widthSel, 'Select width…'); }
    /* Height stays disabled until a width is answered — `simple_height` is a 2-D
       array indexed by the width choice, so an enabled height select before that
       is a dead control, which is the Q101 complaint. populateHeights() enables
       it. */
    if (heightSel) { setPlaceholder(heightSel, 'Select height…'); heightSel.disabled = true; }
    /* a 4 s failure that later resolves must not leave its own message up */
    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; }
    if (root) root.setAttribute('data-sizes', 'ready');
    syncChoiceCta();
  }
  function failSizeSelects(text) {
    setPlaceholder(widthSel, 'Sizes did not load');
    setPlaceholder(heightSel, 'Sizes did not load');
    if (widthSel) widthSel.disabled = true;
    if (heightSel) heightSel.disabled = true;
    msg(text || 'Sizes did not load. Call (949) 619-7824.', 'err');
    if (root) root.setAttribute('data-sizes', 'failed');
    syncChoiceCta();
  }

  /* ── State ── */
  var state = { width: null, height: null, model: null };
  var groupData = null;
  var choiceCtaPending = false;
  var choicePendingLabel = 'Adding…';
  var choiceErrorShown = false;

  /* Copy only: reflect the first requirement already enforced by validate().
     Single-option auto-selections and cart/price calculations stay unchanged. */
  function syncChoiceCta() {
    if (!atcBtn) return;
    if (choiceCtaPending || colorSwitchPending) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
      if (atcLabel) atcLabel.textContent = choicePendingLabel;
      if (expressBtn) {
        expressBtn.disabled = true;
        expressBtn.setAttribute('aria-busy', 'true');
        var busyExpressText = expressBtn.querySelector('span:not(.ef-of__express-icon)');
        if (busyExpressText) busyExpressText.textContent = choicePendingLabel;
        expressBtn.setAttribute('aria-label', choicePendingLabel);
      }
      atcBtn.removeAttribute('data-ef-next-label');
      atcBtn.setAttribute('data-ef-cta-state', 'pending');
    } else {
      atcBtn.disabled = false;
      atcBtn.setAttribute('aria-busy', 'false');
      if (expressBtn) { expressBtn.disabled = false; expressBtn.setAttribute('aria-busy', 'false'); }
      var loading = root.getAttribute('data-sizes');
      var label = '', reason = 'selected';
      if (loading === 'failed') { label = 'Sizes unavailable'; reason = 'unavailable'; }
      else if (loading !== 'ready') { label = 'Loading sizes…'; reason = 'loading'; }
      else if (!state.width) { label = 'Choose your width'; reason = 'missing'; }
      else if (!state.height) { label = 'Choose your height'; reason = 'missing'; }
      if (compactOrder && label) { atcBtn.disabled = true; if (expressBtn) expressBtn.disabled = true; }
      if (atcLabel) atcLabel.textContent = label || 'Add to Cart';
      var price = document.getElementById('efOfAtcPrice');
      if (price) {
        price.hidden = !!label;
        if (label) price.style.setProperty('display', 'none', 'important');
        else price.style.removeProperty('display');
      }
      var expressText = expressBtn && expressBtn.querySelector('span:not(.ef-of__express-icon)');
      if (expressText) {
        expressText.textContent = label || 'Express Checkout';
        expressBtn.setAttribute('aria-label', expressText.textContent);
      }
      atcBtn.setAttribute('data-ef-next-label', label || 'Add to Cart');
      atcBtn.setAttribute('data-ef-cta-state', reason);
    }
    try { window.dispatchEvent(new CustomEvent('ef-cfg:cta-changed')); } catch (e) {}
  }

  /* simple_height is a 2D array indexed by width selection
     (e.g. width[0] → heights[0], width[1] → heights[1]). simple_models
     follows the same shape, indexed [widthIdx][heightIdx]. So height
     options must REPOPULATE every time width changes. */
  function populateDropdowns() {
    groupData = findGroupData();
    if (!groupData) {
      failSizeSelects('Sizes did not load. Call (949) 619-7824.');
      return;
    }
    var widths = groupData.simple_width || [];
    if (!widths.length) {
      failSizeSelects('No size options available. Call (949) 619-7824 to order.');
      return;
    }

    /* §R9-H7 — the width options may already be in the HTML (server-rendered
       from the same asset by snippets/ef-orderform-simple-sizes.liquid, so the
       control is complete before any script runs). ADOPT them rather than
       append beside them: the markup owns the labels, THIS FILE owns the money.
       Every option's text, data-price and data-variant-id is (re)written here
       from EF_CFG_DATA, so a stale server label cannot reach a cart line and no
       surcharge variant id is ever served from markup.
       If the two lists disagree in LENGTH the server list is discarded whole and
       the old append path runs — a mismatch is a regeneration bug, not something
       to reconcile item by item. */
    function writeWidthOption(o, w, idx) {
      var p = w.price || 0;
      o.value = w.label;
      o.textContent = w.label + (p > 0 ? ' (+' + moneyDollars(p) + ')' : '');
      o.dataset.idx = idx;
      o.dataset.price = p;
      o.dataset.variantId = w.variantId || '';
    }
    var ssr = widthSel.querySelectorAll('option[data-idx]');
    if (ssr.length && ssr.length === widths.length) {
      for (var si = 0; si < ssr.length; si++) writeWidthOption(ssr[si], widths[si], si);
      root.setAttribute('data-sizes-source', 'server');
    } else {
      for (var di = ssr.length - 1; di >= 0; di--) ssr[di].parentNode.removeChild(ssr[di]);
      widths.forEach(function (w, idx) {
        var o = document.createElement('option');
        writeWidthOption(o, w, idx);
        widthSel.appendChild(o);
      });
      root.setAttribute('data-sizes-source', ssr.length ? 'client (server list rejected: length mismatch)' : 'client');
    }

    /* §R9-H6 — the options are in the DOM; the controls stop lying. */
    enableSizeSelects();

    /* §R9-H10 — publish the resolved group. assets/efx-of-companion.js renders
       the three decision rows from EXACTLY this object, so the labels, the
       opening ranges, the door sizes and the surcharges on screen cannot drift
       from the ones this file prices and sends to the cart. Re-resolving the
       group in the companion would have been a second findGroupData() and a
       second chance to serve the wrong product's sizes — the §R9-H5 defect,
       reintroduced one file over. `tier` is handed over for the same reason:
       one definition of S / L / XL, in the file that prices them. */
    try {
      window._efOfState = { group: groupData, tier: tierFor, state: state };
      document.dispatchEvent(new CustomEvent('ef-of:ready', { detail: { group: groupData } }));
    } catch (e) {}

    if (widths.length === 1) {
      widthSel.value = widths[0].label;
      populateHeights(0);
    }
  }

  function populateHeights(widthIdx) {
    /* Clear existing options except placeholder */
    while (heightSel.options.length > 1) heightSel.remove(1);

    var heightArr = groupData.simple_height && groupData.simple_height[widthIdx];
    if (!Array.isArray(heightArr) || !heightArr.length) {
      heightSel.disabled = true;
      return;
    }
    heightSel.disabled = false;
    heightArr.forEach(function (h, idx) {
      var o = document.createElement('option');
      o.value = h.label;
      var p = h.price || 0;
      o.textContent = h.label + (p > 0 ? ' (+' + moneyDollars(p) + ')' : '');
      o.dataset.idx = idx;
      o.dataset.price = p;
      o.dataset.variantId = h.variantId || '';
      if (hasColorFamily) {
        var sizeName = widthIdx === 1 ? 'Large' : idx === 1 ? 'Medium' : 'Small';
        o.textContent = sizeName + ' · ' + o.textContent;
      }
      heightSel.appendChild(o);
    });
    /* Auto-select if only one height option */
    if (!compactOrder && heightArr.length === 1) heightSel.value = heightArr[0].label;
    onSizeChange();
  }

  function onWidthChange() {
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var widthIdx = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : -1;
    if (widthIdx < 0) {
      heightSel.innerHTML = '<option value="">Select width first…</option>';
      heightSel.disabled = true;
      state.width = null;
      onSizeChange();
      return;
    }
    state.width = widthSel.value;
    populateHeights(widthIdx);
  }

  function onSizeChange() {
    state.width = widthSel.value || null;
    state.height = heightSel.value || null;

    if (state.width && state.height) {
      /* simple_models is 2D — [widthIdx][heightIdx]. */
      var wOpt = widthSel.options[widthSel.selectedIndex];
      var hOpt = heightSel.options[heightSel.selectedIndex];
      var widthIdx  = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : 0;
      var heightIdx = hOpt && hOpt.dataset.idx ? parseInt(hOpt.dataset.idx, 10) : 0;
      var modelArr = groupData.simple_models && groupData.simple_models[widthIdx];
      var match = (Array.isArray(modelArr) && modelArr[heightIdx]) || null;
      state.model = match;

      if (overallBox) overallBox.hidden = false;
      if (overallModel) overallModel.textContent = (match && (match.name || match.label)) || 'Standard Model';
      if (overallDims) {
        overallDims.textContent = (match && match.overall) ? match.overall : (state.width + ' wide × ' + state.height + ' tall');
      }
    } else {
      if (overallBox) overallBox.hidden = true;
    }
    syncColorLinks();
    syncArdmoreLead();
    recomputeTotal();
    if (choiceErrorShown && msgEl) { msgEl.hidden = true; msgEl.textContent = ''; choiceErrorShown = false; }
    syncChoiceCta();
  }

  /* Compute the size tier label (S / L / XL) from width+height indices.
     Only 3 valid combos exist in cfg-simple data:
       - width[0] + height[0] → Standard (S, base price)
       - width[0] + height[1] → L (taller)
       - width[1] + height[0] → XL (wider, only one height option) */
  function tierFor(widthIdx, heightIdx) {
    if (widthIdx === 1) return 'XL';
    if (widthIdx === 0 && heightIdx === 1) return 'L';
    return 'S';
  }

  /* EF_GLASS_PROTECTION_CARD_20261017 — explicit opt-in; compact beside order add-ons. */
  function createGlassProtectionCard(anchor, onChange) {
    var existing = document.getElementById('efGlassProtection');
    if (existing || !anchor) return existing;
    var card = document.createElement('section');
    card.id = 'efGlassProtection';
    card.setAttribute('aria-labelledby', 'efGlassProtectionTitle');
    card.innerHTML = "<style>#efGlassProtection{box-sizing:border-box;background:#fbf8f2;border:1px solid #c7ad7b;border-radius:8px;padding:14px 16px;margin:16px 0;width:100%;font-family:inherit;color:#242424}#efGlassProtection .ef-gp-choice{display:flex;align-items:center;gap:11px;min-height:44px;padding:0;margin:0;cursor:pointer;font-family:inherit;font-size:15px;font-weight:600;line-height:1.35;text-transform:none;letter-spacing:0}#efGlassProtection input{appearance:auto;position:static;opacity:1;flex:0 0 20px;width:20px;height:20px;margin:0;accent-color:#86652f;cursor:pointer}#efGlassProtection input:focus-visible,#efGlassProtection summary:focus-visible{outline:2px solid #86652f;outline-offset:4px}#efGlassProtection .ef-gp-price{margin-left:auto;flex:0 0 auto;text-align:right;white-space:nowrap;font-size:16px;line-height:1.25}#efGlassProtection .ef-gp-price small{display:block;font-size:11px;font-weight:400;margin-top:3px}#efGlassProtection .ef-gp-benefit{font-size:13px;line-height:1.5;margin:5px 0 3px 31px;color:#555}#efGlassProtection details{margin-left:31px;font-size:12px;line-height:1.5}#efGlassProtection summary{display:list-item;width:fit-content;max-width:100%;cursor:pointer;text-decoration:underline;text-underline-offset:2px;min-height:36px;box-sizing:border-box;padding:8px 0;font-size:12px;line-height:20px}#efGlassProtection details p{font-size:13px;line-height:1.5;margin:8px 0}#efGlassProtection[hidden]{display:none!important}@media(max-width:480px){#efGlassProtection{padding:12px}#efGlassProtection .ef-gp-choice{gap:9px;font-size:14px}#efGlassProtection .ef-gp-benefit,#efGlassProtection details{margin-left:29px}#efGlassProtection .ef-gp-price{font-size:15px}}</style><label class=\"ef-gp-choice\" for=\"efGlassProtectionCheck\"><input type=\"checkbox\" id=\"efGlassProtectionCheck\" aria-describedby=\"efGlassProtectionBenefit\"><span id=\"efGlassProtectionTitle\">Add Lifetime Glass Protection</span><span class=\"ef-gp-price\">+$99<small>one-time</small></span></label><p class=\"ef-gp-benefit\" id=\"efGlassProtectionBenefit\">Optional protection by ExceptionalFire for accidental and heat-related glass breakage during proper use. Replacement shipping included.</p><details><summary>Coverage details</summary><p>Your manufacturer’s warranty remains included whether or not you add this plan.</p><p>This ExceptionalFire plan covers replacement glass for accidental breakage and heat-related breakage during proper use, for the original purchaser for as long as they own the covered doors. Replacement shipping and claim handling are included. Frames, finishes and installation labor are not covered.</p><p>Always follow the manufacturer’s operating instructions, including whether doors must remain open while a fire is burning. This plan does not authorize use contrary to those instructions.</p><p>ExceptionalFire is responsible for this plan and any coverage beyond the manufacturer’s warranty. To request replacement glass, contact ExceptionalFire with your order number and photos of the damage. This plan supplements your existing manufacturer warranty.</p></details>";
    // Quick Ship: after photo/notes, before the final price and order controls.
    anchor.parentNode.insertBefore(card, anchor);
    card.querySelector('input').addEventListener('change', function(e) { onChange(e.target.checked); });
    return card;
  }

  function simpleGlassProtectionSelected() { var c=document.getElementById('efGlassProtectionCheck');return !!(c && c.checked); }
  function recomputeTotal() {
    if (["design-specialties-brookfield-custom-fireplace-doors","cabot-fireplace-glass-door-for-masonry","black-rock-arch-masonry-fireplace-glass-doors","design-specialties-buckingham-arch-custom-fireplace-doors-masonry","design-specialties-legend-arch-custom-fireplace-doors-masonry","design-specialties-stiletto-custom-fireplace-doors","design-specialties-bungalow-custom-fireplace-doors","design-specialties-carolina-standard-custom-fireplace-doors-1","design-specialties-carolina-arched-and-window-pane-custom-fireplace-doors","design-specialties-carolina-arched-custom-fireplace-doors-2","design-specialties-carolina-sunrise-custom-fireplace-doors","design-specialties-oak-tree-custom-fireplace-doors","design-specialties-mantel-custom-fireplace-doors","design-specialties-napa-valley-custom-fireplace-doors","design-specialties-legend-odyssey-custom-fireplace-doors","design-specialties-original-moderne-custom-fireplace-doors-2","design-specialties-slim-moderne-custom-fireplace-doors-3","design-specialties-legend-standard-custom-fireplace-doors","banded-scroll-masonry-prefab-fireplace-glass-doors","design-specialties-craftsman-custom-fireplace-doors-1","design-specialties-madrid-custom-fireplace-doors-2","design-specialties-hammered-edge-standard-custom-fireplace-doors","design-specialties-black-rock-custom-fireplace-doors","design-specialties-apex-custom-fireplace-doors","design-specialties-reflection-custom-fireplace-doors","design-specialties-piccolo-custom-fireplace-doors","design-specialties-rainbow-custom-fireplace-doors","design-specialties-stiletto-cutback-custom-fireplace-doors","stainless-steel-masonry-fireplace-door","design-specialties-carolina-standard-custom-fireplace-doors-2","design-specialties-legend-odyssey-custom-fireplace-doors-1","thinlinepro-custom-fireplace-doors","mission-custom-fireplace-doors","design-specialties-original-moderne-custom-fireplace-doors-5","madison-custom-fireplace-doors","innovative-custom-fireplace-doors","masonry-prefab-fireplace-glass-doors","iron-crafted-custom-fireplace-doors","aged-world-fireplace-glass-doors-exceptional-fire","smithline-masonry-and-prefab-fireplace-glass-doors","metro-custom-fireplace-doors","midway-flames-custom-fireplace-doors","timeless-flames-custom-fireplace-doors","bar-iron-masonry-prefab-fireplace-doors","edgeline-custom-fireplace-doors","deepset-custom-fireplace-doors-2","sierra-custom-steel-masonry-prefab-fireplace-doors","sierra-arch-pane-custom-steel-masonry-prefab-fireplace-doors","sierra-windows-pane-custom-steel-masonry-prefab-fireplace-doors","bar-crafts-custom-fireplace-doors-6","belmont-custom-masonry-fireplace-glass-doors","wheatland-custom-masonry-fireplace-glass-doors","seaside-standard-glass-doors-designed-for-all-prefabricated-fireplaces","monterey-standard-glass-doors-designed-for-all-prefabricated-fireplaces","openview-masonry-prefab-fireplace-doors","edgewood-masonry-fireplace-door","ashford-masonry-fireplace-door","blacksmith-arch-masonry-and-prefab-fireplace-glass-doors","forged-iron-arch-conversion-masonry-and-prefab-fireplace-glass-doors","old-world-arch-masonry-distressed-steel-fireplace-glass-doors","bar-iron-arch-masonry-steel-fireplace-glass-doors","industrial-arch-masonry-steel-fireplace-glass-doors","smithline-arch-conversion-masonry-and-prefab-fireplace-glass-doors","ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design","armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design","grande-flat-black-masonry-fireplace-door-standard-sizes","reflection-flat-black-masonry-fireplace-door-standard-sizes","medio-flat-black-masonry-fireplace-door-standard-sizes","finley-flat-black-masonry-fireplace-door-standard-sizes","farnsworth-oil-rubbed-bronze-masonry-fireplace-door-standard-sizes","colt-flat-black-masonry-fireplace-door-standard-sizes","colt-gun-metal-masonry-fireplace-door-standard-sizes","alexander-natural-iron-masonry-fireplace-door-standard-sizes","brookfield-deluxe-magnetic-prefab-fireplace-glass-doors","medio-flat-black-masonry-fireplace-door-custom-size","carolina-traditional-steel-fireplace-glass-doors-masonry-prefab","milwaukee-forged-iron-masonry-prefab-fireplace-glass-doors","laguna-arch-pane-masonry-prefab-fireplace-glass-doors","cavestone-fireplace-glass-doors-custom-masonry-fit","savannah-masonry-prefab-fireplace-glass-doors","all-glass-steel-fireplace-glass-doors-masonry-prefab"].indexOf(PRODUCT_HANDLE) !== -1) createGlassProtectionCard(document.getElementById('efSimpleProtection') || document.getElementById('efOfTotal'), function() { recomputeTotal(); });
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var hOpt = heightSel.options[heightSel.selectedIndex];
    var widthSur  = wOpt && parseInt(wOpt.dataset.price || '0', 10) || 0;
    var heightSur = hOpt && parseInt(hOpt.dataset.price || '0', 10) || 0;
    var widthIdx  = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : -1;
    var heightIdx = hOpt && hOpt.dataset.idx ? parseInt(hOpt.dataset.idx, 10) : -1;

    /* Surcharge prices in EF_CFG_DATA are DOLLARS (per project memory). */
    var totalDollars = (BASE_PRICE / 100) + widthSur + heightSur;
    var totalCents = Math.round(totalDollars * 100) + (simpleGlassProtectionSelected() ? 9900 : 0);
    if (hasColorFamily) {
      var heroPrice = document.getElementById('ef-price-display');
      if (heroPrice) heroPrice.textContent = money(BASE_PRICE);
    }

    if (baseAmt) baseAmt.textContent = money(BASE_PRICE);
    if (totalAmt) totalAmt.textContent = money(totalCents);
    var atcPrice = document.getElementById('efOfAtcPrice');
    if (atcPrice) atcPrice.textContent = money(totalCents);

    /* Render single combined "+ Size L (+$74)" or "+ Size XL (+$124)" row
       between Base and Total when upgrade selected. Replaces the previous
       two separate "Simple Width" / "Simple Height" lines per user request. */
    var totalEl = document.getElementById('efOfTotal');
    if (hasColorFamily && totalEl && !compactOrder) {
      if (!state.width || !state.height) totalEl.style.setProperty('display', 'none', 'important');
      else totalEl.style.removeProperty('display');
    }
    var sizeRow = document.getElementById('efOfSimpleSizeRow');
    var sizeUpDollars = widthSur + heightSur;
    var tier = tierFor(widthIdx, heightIdx);
    state.tier = tier;

    if (totalEl && sizeUpDollars > 0 && tier !== 'S') {
      if (!sizeRow) {
        sizeRow = document.createElement('div');
        sizeRow.id = 'efOfSimpleSizeRow';
        sizeRow.className = 'ef-of__total-row';
        var baseRow = totalEl.querySelector('.ef-of__total-row');
        if (baseRow && baseRow.nextSibling) {
          totalEl.insertBefore(sizeRow, baseRow.nextSibling);
        } else {
          totalEl.appendChild(sizeRow);
        }
      }
      sizeRow.innerHTML = '<span class="ef-of__total-lbl">+ Size ' + (hasColorFamily ? (tier === 'L' ? 'Medium' : 'Large') : tier) + '</span>'
        + '<span class="ef-of__total-amt">+' + moneyDollars(sizeUpDollars) + '</span>';
    } else if (sizeRow) {
      sizeRow.remove();
    }
    if (compactOrder) {
      var selected = !!(state.width && state.height);
      root.setAttribute('data-simple-selected', selected ? 'true' : 'false');
      var opening = document.getElementById('efSimpleOpening');
      if (opening) opening.textContent = selected ? state.width + ' W × ' + state.height + ' H' : '';
      var priceLabel = document.getElementById('efSimplePriceLabel');
      if (priceLabel) priceLabel.textContent = selected ? 'Your price' : 'Starting price';
      var prompt = document.getElementById('efSimplePricePrompt'), delivery = document.getElementById('efSimpleDelivery');
      if (prompt) prompt.hidden = selected;
      if (delivery) delivery.hidden = !selected;
      var sizeTitle = document.getElementById('efSimpleSizeTitle');
      if (sizeTitle) sizeTitle.textContent = !selected ? '' : hasColorFamily ? (widthIdx === 1 ? 'Large' : heightIdx === 1 ? 'Medium' : 'Small') : (state.model && (state.model.name || state.model.label) || '');
      var modelDetail = document.getElementById('efOfSimpleModel');
      if (modelDetail) modelDetail.hidden = !hasColorFamily;
      syncArdmoreLead();
      var protection = document.getElementById('efSimpleProtectionSelected');
      if (protection) protection.hidden = !simpleGlassProtectionSelected();
    }
  }

  /* ── Drop-zone for photo upload — same pattern as orderform-doors. ── */
  if (fileInput && fileLabel) {
    var fileDrop = document.getElementById('efOfFileDrop');
    var fileIcon = fileDrop && fileDrop.querySelector('.ef-of__upload-icon');
    var fileHint = fileDrop && fileDrop.querySelector('.ef-of__upload-hint');
    var preview = null;

    function showPreview(dataUrl, name) {
      if (!fileDrop) return;
      if (!preview) {
        preview = document.createElement('div');
        preview.className = 'ef-of__upload-preview';
        preview.innerHTML = '<img class="ef-of__upload-preview__img" alt="">'
          + '<button type="button" class="ef-of__upload-preview__remove" aria-label="Remove">'
          + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg></button>';
        fileDrop.insertBefore(preview, fileIcon);
        preview.querySelector('button').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          fileInput.value = '';
          fileInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      preview.querySelector('img').src = dataUrl;
      preview.style.display = '';
      if (fileIcon) fileIcon.style.display = 'none';
      if (fileHint) fileHint.textContent = 'Click to replace · ' + (name || '');
      fileDrop.classList.add('has-file');
    }
    function hidePreview() {
      if (preview) preview.style.display = 'none';
      if (fileIcon) fileIcon.style.display = '';
      if (fileHint) fileHint.textContent = 'JPG, PNG up to 10MB';
      fileDrop.classList.remove('has-file');
    }
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) {
        fileLabel.textContent = f.name;
        var r = new FileReader();
        r.onload = function (e) { showPreview(e.target.result, f.name); };
        r.readAsDataURL(f);
      } else {
        fileLabel.textContent = 'Drag a photo here or click to browse';
        hidePreview();
      }
    });
    if (fileDrop) {
      ['dragenter','dragover'].forEach(function (e) {
        fileDrop.addEventListener(e, function (ev) { ev.preventDefault(); ev.stopPropagation(); fileDrop.classList.add('is-dragover'); });
      });
      ['dragleave','drop'].forEach(function (e) {
        fileDrop.addEventListener(e, function (ev) { ev.preventDefault(); ev.stopPropagation(); fileDrop.classList.remove('is-dragover'); });
      });
      fileDrop.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(files[0]);
          fileInput.files = dt.files;
        } catch (err) {}
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /* ── ATC ── */
  function buildCartItems() {
    var configId = 'cfg-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    /* No _parent_product on main — orphan cleanup classifies items WITHOUT
       _parent_product as main; with would mark all as orphans. */
    var properties = { _config_id: configId };
    if (hasColorFamily) properties['Color'] = selectedColorLabel();
    if (state.width)  properties['Opening Width']  = state.width;
    if (state.height) properties['Opening Height'] = state.height;
    if (state.tier && state.tier !== 'S') properties['Size'] = hasColorFamily ? (state.tier === 'L' ? 'Medium' : 'Large') : state.tier;
    if (hasColorFamily) { properties['Size'] = properties['Size'] || 'Small'; properties['_standard_size_code'] = state.tier; }
    if (state.model && (state.model.name || state.model.label)) {
      properties['Model'] = state.model.name || state.model.label;
    }
    if (notesEl && notesEl.value) properties['Notes'] = notesEl.value;

    var mainId = parseInt(BASE_VARIANT_ID, 10);
    if (!mainId || isNaN(mainId)) {
      console.error('[ef-orderform-simple] Missing BASE_VARIANT_ID');
      return [];
    }
    var items = [{ id: mainId, quantity: 1, properties: properties }];

    /* Width / height surcharges as separate line items (each has its own
       hidden Shopify variant) but TAGGED with the unified Size tier name
       so the cart drawer can group them under "Size L" / "Size XL" rather
       than "Simple Width" / "Simple Height". */
    var sizeLabel = state.tier && state.tier !== 'S' ? ('Size ' + (hasColorFamily ? properties['Size'] : state.tier)) : null;
    [widthSel, heightSel].forEach(function (sel) {
      var opt = sel && sel.options[sel.selectedIndex];
      if (!opt) return;
      var vid = parseInt(opt.dataset.variantId || '', 10);
      var price = parseInt(opt.dataset.price || '0', 10);
      if (!vid || isNaN(vid) || price <= 0) return;
      items.push({
        id: vid, quantity: 1,
        properties: {
          _parent_product: PRODUCT_TITLE,
          _option_type: sizeLabel || 'Size',
          _config_id: configId
        }
      });
    });
    if (simpleGlassProtectionSelected()) {
      properties['Glass Protection'] = 'Lifetime Glass Protection by ExceptionalFire — $99';
      items.push({id:42820684677202,quantity:1,properties:{_parent_product:PRODUCT_TITLE,_option_type:'Glass Protection',_config_id:configId}});
    }
    return items;
  }

  function validate() {
    if (!state.width || !state.height) {
      choiceErrorShown = true;
      msg(state.width ? 'Choose your height to continue.' : 'Choose your width to continue.', 'err');
      try { (state.width ? heightSel : widthSel).focus(); } catch (e) {}
      return false;
    }
    return true;
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (choiceCtaPending || atcBtn.disabled) return;
      if (!validate()) return;
      var origLabel = atcLabel ? atcLabel.textContent : 'Add to Cart';
      choicePendingLabel = 'Adding…';
      choiceCtaPending = true;
      syncChoiceCta();
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding…';
      syncChoiceCta();
      var items = buildCartItems();
      console.group('[ef-orderform-simple] ATC payload');
      items.forEach(function (it, i) { console.log('  [' + i + ']', it); });
      console.groupEnd();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || ('Cart ' + r.status));
          return j;
        });
      })
      .then(function () {
        if (atcLabel) atcLabel.textContent = 'Added ✓';
        atcBtn.style.background = '#1F7A3A';
        msg('Added to cart!', 'ok');
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        setTimeout(function () {
          if (window.EFCartDrawer && window.EFCartDrawer.open) window.EFCartDrawer.open();
          else window.location.href = '/cart';
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.style.background = '';
            if (atcLabel) atcLabel.textContent = origLabel;
            choiceCtaPending = false;
            syncChoiceCta();
          }, 1200);
        }, 700);
      })
      .catch(function (err) {
        console.error('[ef-orderform-simple] ATC failed:', err);
        msg('Could not add: ' + err.message + '. Try again or call (949) 619-7824.', 'err');
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = origLabel;
        choiceCtaPending = false;
        syncChoiceCta();
      });
    });
  }

  if (expressBtn) {
    expressBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (choiceCtaPending || expressBtn.disabled) return;
      if (!validate()) return;
      choicePendingLabel = 'Starting checkout…';
      choiceCtaPending = true;
      syncChoiceCta();
      expressBtn.disabled = true;
      var origText = 'Express Checkout';
      var span = expressBtn.querySelector('span:not(.ef-of__express-icon)');
      if (span) span.textContent = 'Starting checkout…';
      expressBtn.setAttribute('aria-label', 'Starting checkout…');
      syncChoiceCta();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildCartItems() })
      })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        expressBtn.disabled = false;
        if (span) span.textContent = origText;
        choiceCtaPending = false;
        syncChoiceCta();
        msg('Express Checkout failed. Try regular Add to Cart.', 'err');
      });
    });
  }

  /* Native sibling colors, swapped in place. The order form and its input/file
     nodes stay mounted; all money/IDs come from the target's server response. */
  var colorSwitchPending = false;
  // The existing native model-preview initializer, reused only when mounting its first preview.
  function initInlineModelPreview() {

          (function () {
            var root = document.querySelector('.ef-model-preview');
            if (!root || root.dataset.ready) return;
            root.dataset.ready = 'true';
            var dialog = root.querySelector('dialog'), stage = root.querySelector('[data-model-stage]');
            var qr = root.querySelector('[data-model-qr]'), status = root.querySelector('[data-model-status]');
            var reset = root.querySelector('[data-model-reset]'), room = root.querySelector('[data-model-room]');
            var back = root.querySelector('[data-model-back]'), retry = root.querySelector('[data-model-retry]');
            var title = root.querySelector('#efModelTitle'), viewer, originFocus, originalOverflow, loading, timeout;
            var mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
            function fail() { clearTimeout(timeout); loading = null; status.textContent = 'The 3D preview could not load. Please try again.'; retry.hidden = false; }
            function loadViewer() {
              if (viewer && viewer.loaded) return Promise.resolve(viewer);
              if (loading) return loading;
              retry.hidden = true; status.textContent = 'Loading your 3D preview…';
              loading = new Promise(function (resolve, reject) {
                timeout = setTimeout(function () { reject(new Error('Model timeout')); }, 45000);
                function create() {
                  stage.replaceChildren(); viewer = document.createElement('model-viewer');
                  viewer.setAttribute('src', root.dataset.glb);
                  if (root.dataset.usdz) viewer.setAttribute('ios-src', root.dataset.usdz);
                  viewer.setAttribute('alt', 'Interactive 3D preview of the fireplace door');
                  ['camera-controls', 'ar'].forEach(function (a) { viewer.setAttribute(a, ''); });
                  viewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
                  viewer.setAttribute('ar-placement', 'wall');
                  viewer.setAttribute('environment-image', 'neutral');
                  viewer.setAttribute('exposure', '1.15');
                  viewer.setAttribute('shadow-intensity', '0.6');
                  viewer.setAttribute('camera-orbit', '15deg 82deg auto');
                  viewer.setAttribute('touch-action', 'pan-y');
                  var hideNative = document.createElement('span'); hideNative.slot = 'ar-button'; viewer.append(hideNative);
                  viewer.addEventListener('load', function () { clearTimeout(timeout); status.textContent = 'Drag to rotate · pinch or scroll to zoom'; resolve(viewer); }, {once:true});
                  viewer.addEventListener('error', function () { reject(new Error('Model failed')); }, {once:true});
                  viewer.addEventListener('ar-status', function (e) { if (e.detail.status === 'failed') status.textContent = 'Room preview is unavailable on this device. You can still explore the door in 3D.'; });
                  stage.append(viewer);
                }
                if (customElements.get('model-viewer')) { create(); return; }
                var script = document.querySelector('script[data-ef-model-loader]');
                if (!script) { script = document.createElement('script'); script.type = 'module'; script.src = 'https://unpkg.com/@google/model-viewer@4.0.0/dist/model-viewer.min.js'; script.dataset.efModelLoader = 'true'; document.head.append(script); }
                script.addEventListener('error', function () { script.remove(); reject(new Error('Viewer failed')); }, {once:true});
                customElements.whenDefined('model-viewer').then(create);
              }).catch(function () { fail(); return null; });
              return loading;
            }
            function modelMode() {
              title.textContent = 'Explore in 3D'; stage.hidden = false; qr.hidden = true;
              reset.hidden = false; room.hidden = false; back.hidden = true;
              loadViewer().then(function (v) { if (v && !stage.hidden) status.textContent = 'Drag to rotate · pinch or scroll to zoom'; });
            }
            function roomMode() {
              if (!mobile) {
                title.textContent = 'View in your room'; stage.hidden = true; qr.hidden = false;
                reset.hidden = true; room.hidden = true; back.hidden = false; retry.hidden = true; status.textContent = '';
                var url = new URL(root.dataset.productUrl, location.origin); url.searchParams.set('ef3d', 'room');
                if (window.Shopify && Shopify.theme && Shopify.theme.role === 'unpublished') url.searchParams.set('preview_theme_id', Shopify.theme.id);
                var img = qr.querySelector('img'); img.onerror = function () { status.textContent = 'QR code could not load. Open this product on your phone and tap View in your room.'; };
                img.src = 'https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=8&data=' + encodeURIComponent(url.href);
                return;
              }
              modelMode();
              loadViewer().then(function (v) {
                if (!v || !dialog.open) return;
                if (v.canActivateAR) { v.activateAR().catch(function () { status.textContent = 'Tap View in your room again to open your camera preview.'; }); }
                else status.textContent = 'Room preview needs a compatible phone. You can still rotate and zoom in 3D.';
              });
            }
            function open(mode) {
              originFocus = document.activeElement;
              if (!dialog.open) { originalOverflow = document.documentElement.style.overflow; dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
              if (mode === 'room') roomMode(); else modelMode();
            }
            root.querySelectorAll('[data-model-open]').forEach(function (button) { button.addEventListener('click', function () { open(button.dataset.modelOpen); }); });
            root.querySelector('[data-model-close]').addEventListener('click', function () { dialog.close(); });
            dialog.addEventListener('click', function (e) { if (e.target === dialog) { var r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
            dialog.addEventListener('close', function () { document.documentElement.style.overflow = originalOverflow; if (originFocus) originFocus.focus({preventScroll:true}); });
            reset.addEventListener('click', function () { if (viewer) { viewer.cameraOrbit = '15deg 82deg auto'; viewer.cameraTarget = 'auto auto auto'; viewer.fieldOfView = 'auto'; } });
            room.addEventListener('click', roomMode); back.addEventListener('click', modelMode); retry.addEventListener('click', function () { loading = null; modelMode(); });
            if (new URLSearchParams(location.search).get('ef3d') === 'room') {
              open('model');
              status.textContent = 'Loading the door. Then tap View in your room.';
              loadViewer().then(function (v) { if (v) status.textContent = 'Tap View in your room to open the camera preview.'; });
            }
          })();
          
  }
  function initInlineColors() {
    if (!compactOrder || !hasColorFamily) return;
    var colors = document.getElementById('efStandardColors');
    if (!colors) return;
    var black = colorFamily[0].handle;
    var grey = colorFamily[1].handle;
    var serial = 0, controller, renderedUrl = location.href;
    var status = document.getElementById('efStandardColorStatus');
    function tell(text) { if (status) { status.textContent = text; status.hidden = !text; } }
    function selection() {
      var w = widthSel.options[widthSel.selectedIndex], h = heightSel.options[heightSel.selectedIndex];
      return { w: w && w.dataset.idx, h: h && h.dataset.idx };
    }
    function code(pair) { return pair.w != null && pair.h != null ? (pair.w === '1' ? 'L' : pair.h === '1' ? 'M' : 'S') : ''; }
    function sizedURL(url, pair) {
      var u = new URL(url, location.href), size = code(pair);
      if (size) u.searchParams.set('ef_size', size); else u.searchParams.delete('ef_size');
      return u;
    }
    function contents(doc, selector) {
      var from = doc.querySelector(selector), to = document.querySelector(selector);
      if (from && to) to.replaceChildren.apply(to, Array.from(from.childNodes).filter(function (n) { return n.nodeName !== 'SCRIPT'; }).map(function (n) { return document.importNode(n, true); }));
    }
    function applyPage(doc, target, data, pair, url) {
      // Validate the complete purchase payload and gallery before any mutation.
      var nextMain = doc.querySelector('#efGallerySwiper'), nextThumbs = doc.querySelector('#efGalleryThumbs');
      var main = document.getElementById('efGallerySwiper'), thumbs = document.getElementById('efGalleryThumbs');
      if (!nextMain || !nextThumbs || !main || !thumbs || !window.EFGallery || !window.EFGallery.main || !window.EFGallery.thumbs || !nextMain.querySelector('.swiper-wrapper') || !nextThumbs.querySelector('.swiper-wrapper')) throw new Error('Gallery not ready');
      if (!data.simple_width || !data.simple_height || !data.simple_models || !data.simple_models[0] || !data.simple_models[0][0]) throw new Error('Invalid sizes');
      if (!/^\d+$/.test(target.dataset.variantId) || !Number.isFinite(Number(target.dataset.basePrice))) throw new Error('Invalid product');
      var restoredW = pair.w == null ? -1 : Number(pair.w), restoredH = pair.h == null ? -1 : Number(pair.h);
      if (restoredW >= 0 && (!data.simple_width[restoredW] || !data.simple_height[restoredW] || (restoredH >= 0 && !data.simple_height[restoredW][restoredH]))) throw new Error('Selected size unavailable');

      BASE_VARIANT_ID = target.dataset.variantId;
      BASE_PRICE = Number(target.dataset.basePrice);
      PRODUCT_HANDLE = target.dataset.productHandle;
      PRODUCT_TITLE = target.dataset.productTitle;
      CFG_GROUP = target.dataset.cfgGroup;
      isArdmore = PRODUCT_HANDLE === 'ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design';
      isArmitage = PRODUCT_HANDLE === 'armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design';
      Object.keys(target.dataset).forEach(function (k) { if (/^(product|variant|basePrice|compare|cfgGroup)/.test(k)) root.dataset[k] = target.dataset[k]; });
      window.EF_CFG_DATA[CFG_GROUP] = data;
      var variant = document.getElementById('efOfVariantId'); if (variant) variant.value = BASE_VARIANT_ID;
      ['.efx-pdp__title', '.efx-pdp__qualifier', '.efx-pdp__rating', '.efx-pdp__foldproof', '.efx-pdp__price-row', '.efx-pdp__price-note', '.efx-breadcrumbs', '.efx-breadcrumb', '.efx-pdp__crumbs', '.ef-of__head'].forEach(function (s) { contents(doc, s); });
      // Financing metadata belongs to the new native product as well.
      var fin = document.querySelector('.ef-fin-badge'), nextFin = doc.querySelector('.ef-fin-badge');
      if (fin && nextFin) { fin.dataset.price = nextFin.dataset.price; contents(doc, '.ef-fin-badge'); }
      var nextLead = doc.querySelector('.efx-pdp__leadtime > span');
      shippingDefault = nextLead.innerHTML; shippingBaseText = nextLead.textContent.replace(/^.*?·\s*/, '');
      document.querySelectorAll('.efx-specs details[id]').forEach(function (el) { contents(doc, '.efx-specs details[id="' + el.id + '"]'); });
      contents(doc, '.efx-specs__rail');
      contents(doc, '#ef-reviews-section .efx-pdp__sechead');
      var reviews = document.getElementById('looxReviews'), nextReviews = doc.getElementById('looxReviews');
      if (reviews && nextReviews) {
        reviews.dataset.productId = nextReviews.dataset.productId;
        if (window.LOOX) window.LOOX.productId = nextReviews.dataset.productId;
        var frame = reviews.querySelector('iframe');
        if (frame) {
          var frameURL = new URL(frame.dataset.efSource || frame.src);
          frameURL.pathname = frameURL.pathname.replace(/\/reviews\/\d+/, '/reviews/' + target.dataset.productId);
          // Replacing the iframe's location avoids extra joint-history entries
          // which would otherwise consume the customer's first Back click.
          frame.dataset.efSource = frameURL.href;
          try { frame.contentWindow.location.replace(frameURL.href); }
          catch (e) { var fresh = frame.cloneNode(false); fresh.src = frameURL.href; frame.replaceWith(fresh); }
        }
        else contents(doc, '#looxReviews');
      }
      // Keep gallery instances/zoom handlers; replace their native slide content.
      window.EFGallery.closeLightbox();
      main.querySelectorAll('video').forEach(function (v) { v.pause(); });
      contents(doc, '#efGallerySwiper > .swiper-wrapper'); contents(doc, '#efGalleryThumbs > .swiper-wrapper');
      main.dataset.productHandle = PRODUCT_HANDLE;
      contents(doc, '#ef-pd-counter');
      window.EFGallery.thumbs.update(); window.EFGallery.main.update();
      window.EFGallery.main.slideTo(0, 0); window.EFGallery.thumbs.slideTo(0, 0);
      if (window.EFGallery.main.thumbs) window.EFGallery.main.thumbs.update(true);
      var zoom = document.getElementById('efGalleryZoom'); if (zoom) zoom.hidden = false;
      var preview = document.querySelector('.ef-model-preview'), nextPreview = doc.querySelector('.ef-model-preview');
      if (preview && !nextPreview) {
        var openDialog = preview.querySelector('dialog');
        if (openDialog && openDialog.open) { var closePreview = preview.querySelector('[data-model-close]'); if (closePreview) closePreview.click(); }
        preview.hidden = true;
      }
      if (!preview && nextPreview) {
        preview = document.importNode(nextPreview, true);
        document.querySelector('.ef-pd-gallery').appendChild(preview);
        initInlineModelPreview();
      }
      if (preview && nextPreview) {
        preview.hidden = false;
        ['glb', 'usdz', 'productUrl'].forEach(function (k) { preview.dataset[k] = nextPreview.dataset[k] || ''; });
        var dialog = preview.querySelector('dialog'); if (dialog && dialog.open) { var close = preview.querySelector('[data-model-close]'); if (close) close.click(); }
        preview.querySelectorAll('model-viewer').forEach(function (v) { v.setAttribute('src', preview.dataset.glb); if (preview.dataset.usdz) v.setAttribute('ios-src', preview.dataset.usdz); else v.removeAttribute('ios-src'); });
      }
      contents(doc, '.ef-standard-colors__title');
      colors.querySelectorAll('[data-ef-color-target]').forEach(function (a) { var active = (a.dataset.efColorTarget === 'black') === (PRODUCT_HANDLE === black); if (active) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
      populateDropdowns();
      widthSel.value = restoredW >= 0 ? data.simple_width[restoredW].label : '';
      onWidthChange();
      if (restoredH >= 0) { heightSel.value = data.simple_height[restoredW][restoredH].label; onSizeChange(); }
      document.title = doc.title;
      // Keep client-side Product structured data consistent with the selected listing.
      var currentSchema = Array.from(document.querySelectorAll('script[type="application/ld+json"]')).filter(function (s) { return /"@type"\s*:\s*"Product"/.test(s.textContent); });
      var nextSchema = Array.from(doc.querySelectorAll('script[type="application/ld+json"]')).filter(function (s) { return /"@type"\s*:\s*"Product"/.test(s.textContent); });
      if (currentSchema.length === nextSchema.length) currentSchema.forEach(function (s, i) { s.textContent = nextSchema[i].textContent; });
      ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]', 'meta[property="og:description"]'].forEach(function (s) { var a = document.querySelector(s), n = doc.querySelector(s); if (a && n) a.setAttribute(a.tagName === 'LINK' ? 'href' : 'content', n.getAttribute(a.tagName === 'LINK' ? 'href' : 'content')); });
      document.dispatchEvent(new CustomEvent('ef:standard-color-changed', {detail:{productId:target.dataset.productId,handle:PRODUCT_HANDLE,variantId:BASE_VARIANT_ID,color:selectedColorLabel(),size:code(pair)}}));
    }
    async function change(url, isPop) {
      var targetURL = new URL(url, location.href), handle = targetURL.pathname.split('/').filter(Boolean).pop();
      if (handle !== black && handle !== grey) return;
      if (choiceCtaPending) { tell('Please wait for your cart update to finish.'); return; }
      var request = ++serial; if (controller) controller.abort();
      if (handle === PRODUCT_HANDLE) {
        colorSwitchPending = false; syncChoiceCta(); tell(''); colors.removeAttribute('aria-busy');
        if (isPop) restoreColorSize(); return;
      }
      var pair = selection();
      if (isPop) { var preset = {S:['0','0'],M:['0','1'],L:['1','0']}[targetURL.searchParams.get('ef_size')]; if (preset) pair = {w:preset[0],h:preset[1]}; }
      targetURL = sizedURL(targetURL, pair);
      var startedHandle = PRODUCT_HANDLE;
      controller = new AbortController(); var activeController = controller;
      var timer = setTimeout(function () { activeController.abort(); }, 12000);
      colorSwitchPending = true; choicePendingLabel = 'Changing color…'; colors.setAttribute('aria-busy', 'true'); syncChoiceCta(); tell('Loading ' + (handle === grey ? colorFamily[1].label : colorFamily[0].label) + '…');
      try {
        var response = await fetch(targetURL.pathname + targetURL.search, {signal:controller.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error('Product unavailable');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (request !== serial) return;
        var target = doc.getElementById('efOf');
        if (!target || target.dataset.productHandle !== handle || !doc.querySelector('.efx-pdp__leadtime > span')) throw new Error('Wrong product response');
        var prefix = 'window.EF_CFG_DATA[' + JSON.stringify(target.dataset.cfgGroup) + ']=';
        var source = Array.from(doc.scripts).find(function (s) { return s.textContent.indexOf(prefix) !== -1; });
        // Finley's existing native table uses this explicit legacy key.
        // Never adopt another product's first/fuzzy data block during a switch.
        if (!source && handle === 'finley-flat-black-masonry-fireplace-door-standard-sizes') {
          prefix = 'window.EF_CFG_DATA[' + JSON.stringify('Fireplace Doors - Finley') + ']=';
          source = Array.from(doc.scripts).find(function (s) { return s.textContent.indexOf(prefix) !== -1; });
        }
        if (!source) throw new Error('Missing native size data');
        var json = source.textContent.slice(source.textContent.indexOf(prefix) + prefix.length).trim().replace(/;\s*$/, '');
        var data = JSON.parse(json);
        var anchorTop = colors.getBoundingClientRect().top;
        if (!isPop) history.replaceState(history.state, '', sizedURL(renderedUrl, selection()));
        applyPage(doc, target, data, pair, targetURL);
        if (!isPop) history.pushState({efInlineColor:true}, '', targetURL);
        renderedUrl = location.href;
        // Keep the customer's position at the color controls while headings resize.
        window.scrollBy(0, colors.getBoundingClientRect().top - anchorTop);
        tell('');
      } catch (e) {
        if (request !== serial) return;
        if (isPop) history.replaceState(history.state, '', renderedUrl);
        if (PRODUCT_HANDLE !== startedHandle) {
          root.setAttribute('data-sizes', 'failed');
          tell('Color could not finish loading. Please refresh this page before ordering.');
        } else tell('Could not change color. Your current selection is unchanged. Please try again.');
      } finally {
        clearTimeout(timer);
        if (request === serial) { colorSwitchPending = false; choicePendingLabel = 'Adding…'; colors.removeAttribute('aria-busy'); syncChoiceCta(); }
      }
    }
    colors.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ef-color-target]');
      if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); e.stopPropagation(); change(link.href, false);
    });
    window.addEventListener('popstate', function () { change(location.href, true); });
  }

  /* ── Boot ── */
  initInlineColors();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", syncArdmoreLead, { once: true });
  syncChoiceCta();
  if (widthSel)  widthSel.addEventListener('change', onWidthChange);
  if (heightSel) heightSel.addEventListener('change', onSizeChange);
  whenDataReady(function (loaded) {
    if (!loaded) {
      failSizeSelects('Sizes did not load. Call (949) 619-7824.');
      return;
    }
    populateDropdowns();
    // Owner-directed default: initialize the native Small pair once on load.
    // User changes still reset height; explicit color-link size restores below.
    if (compactOrder && groupData && groupData.simple_models && groupData.simple_models[0] && groupData.simple_models[0][0]) {
      var defaultWidth = widthSel.querySelector('option[data-idx="0"]');
      if (defaultWidth) {
        widthSel.value = defaultWidth.value;
        onWidthChange();
        var defaultHeight = heightSel.querySelector('option[data-idx="0"]');
        if (defaultHeight) { heightSel.value = defaultHeight.value; onSizeChange(); }
      }
    }
    syncArdmoreLead();
    if (hasColorFamily && groupData) { restoreColorSize(); syncColorLinks(); recomputeTotal(); syncChoiceCta(); }
  });
})();
